export default __webpack_public_path__ + "static/media/mastercard.56ba50cb.svg";